import React from 'react';
import PropTypes from 'prop-types';

import { STAKEHOLDER_TYPES } from '@/containers/withStakeholderLogic';
import PersonSummary from './PersonSummary';

const StakeholderSummary = ({ stakeholder, ...props }) => {
  const { type, roles = [], data, ...s } = stakeholder;
  let summary;
  switch (type) {
    case STAKEHOLDER_TYPES.PERSON:
      summary = <PersonSummary {...props} stakeholder={{ ...s, ...data, roles }} />;
      break;
    case STAKEHOLDER_TYPES.COMPANY:
    default:
      throw new Error('Not implemented');
  }

  return <>{summary}</>;
};

StakeholderSummary.propTypes = {
  ...PersonSummary.propTypes,
  stakeholder: PropTypes.shape({
    data: PropTypes.object.isRequired,
    roles: PropTypes.array.isRequired,
    type: PropTypes.string.isRequired,
  }),
};

export default StakeholderSummary;
